"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSubscriber = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Subscriber2 = require("./Subscriber");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber =
/*#__PURE__*/
function (_Subscriber) {
  (0, _inherits2.default)(InnerSubscriber, _Subscriber);

  function InnerSubscriber(parent, outerValue, outerIndex) {
    var _this;

    (0, _classCallCheck2.default)(this, InnerSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InnerSubscriber).call(this));
    _this.parent = parent;
    _this.outerValue = outerValue;
    _this.outerIndex = outerIndex;
    _this.index = 0;
    return _this;
  }

  (0, _createClass2.default)(InnerSubscriber, [{
    key: "_next",
    value: function _next(value) {
      this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    }
  }, {
    key: "_error",
    value: function _error(error) {
      this.parent.notifyError(error, this);
      this.unsubscribe();
    }
  }, {
    key: "_complete",
    value: function _complete() {
      this.parent.notifyComplete(this);
      this.unsubscribe();
    }
  }]);
  return InnerSubscriber;
}(_Subscriber2.Subscriber);

exports.InnerSubscriber = InnerSubscriber;